export const admissionMenu = [
	{
		"id": 1,
		"icon": "file-text-o",
		"label": "Registration form",
		"to": "/studentRegistration",
		"permission_code": "studentRegistration"
	},
	{
		"id": 10,
		"icon": "toggle-on",
		"label": "Toggle registration form",
		"to": "/toggleRegistrationDate",
		"permission_code": "studentRegistration"
	},
	// {
	// 	"id": 3,
	// 	"icon": "users",
	// 	"label": "All registrations",
	// 	"to": "/allRegistrations",
	// 	"displayToAll": true,
	// },
	// {
	// 	"id": 11,
	// 	"label": "Paid registrations",
	// 	"to": "/allRegistrations/paidRegistrations",
	// 	"displayToAll": true,
	// 	"parentId":3
	// },
	// {
	// 	"id": 4,
	// 	"label": "Unpaid registrations",
	// 	"to": "/allRegistrations/unpaidRegistrations",
	// 	"displayToAll": true,
	// 	"parentId":3
	// },
	{
		"id": 2,
		"icon": "search",
		"label": "Search registrations",
		"to": "/searchRegistrations",
		"permission_code": "searchRegistration"
	},
	{
		"id": 15,
		"icon": 'address-book-o',
		"label": 'Record entrance fees DD',
		"to": "/payments/recordCollegeFees",
		"displayToAll": false,
	},
	{
		"id": 5,
		"icon": 'address-book-o',
		"label": 'Update exam status',
		"to": "/updateExamStatus",
		"displayToAll": false,
	},
	{
		"id": 13,
		"icon": 'address-book-o',
		"label": 'Record course fees',
		"to": "/payments/recordPayments",
		"displayToAll": false,
	},
	{
		"id": 12,
		"icon": "pencil-square-o",
		"label": "Generate ID & roll no.",
		"to": "/generateRollNo",
		"permission_code": "generateRollNo",
		"displayToAll": false
	},
	{
		"id": 14,
		"icon": 'money',
		"label": 'College Fees system',
		"to": "/collegeFeesSystem",
		"displayToAll": false,
	},
	{
		"id": 16,
		"icon": 'users',
		"label": 'Block/unblock student login',
		"to": "/authStudentLogin",
		"displayToAll": false,
	},
	{
		"id": 17,
		"icon": 'money',
		"label": 'Fund Manager',
		"to": "/funds",
		"displayToAll": false,
	}
]
export const universityStaffMenu = [
	{
		"id": 1,
		"icon": "dashboard",
		"label": "Dashboard",
		"to": "/"
	},
	{
		"id": 2,
		"icon": "user-circle-o",
		"label": "Staff",
		"to": "/staff"
	},
	{
		"id": 3,
		"icon": "black-tie",
		"label": "View Profile",
		"to": "/viewUser"
	},
	{
		"id": 4,
		"icon": "bullhorn",
		"label": "Holiday",
		"to": "/holiday"
	}
]
export const universityAdminMenu = [
	{
		"id": 1,
		"icon": "dashboard",
		"label": "Dashboard",
		"to": "/",
		"displayToAll": true
	},
	{
		"id": 2,
		"icon": "users",
		"label": "Subject & Class",
		"to": "/subjectClass",
		"permission_code": "subject_and_class"
	},
	// {
	// 	"id": 17,
	// 	"icon": "book",
	// 	"label": "Add Syllabus",
	// 	"to": "/addSyllabus",
	// 	"permission_code": "syllabus"
	// },
	// {
	// 	"id": 18,
	// 	"icon": "book",
	// 	"label": "View Syllabus",
	// 	"to": "/viewSyllabus",
	// 	"permission_code": "syllabus"
	// },
	{
		"id": 3,
		"icon": "bullhorn",
		"label": "Holiday",
		"to": "/holiday",
		"permission_code": "holiday"
	},
	{
		"id": 4,
		"icon": "black-tie",
		"label": "View Profile",
		"to": "/viewUser",
		"displayToAll": true
	},
	{
		"id": 5,
		"icon": "black-tie",
		"label": "Add User",
		"to": "/addUser",
		"permission_code": "create_user"
	},
	{
		"id": 6,
		"icon": "calendar-times-o",
		"label": "Timetable",
		"to": "/timetable",
		"permission_code": "timetable"
	},
	{
		"id": 7,
        "icon": 'bed',
        "label": 'Leave',
		"to": '/leave',
		"displayToAll": true
    },
	{
		"id": 11,
		"icon": 'calendar-plus',
		"label": 'Apply leave',
		"to": '/leave/apply-leave',
		"parentId": 7,
		"displayToAll": true
	},
	{
		"id": 12,
		"icon": 'calendar-check',
		"label": 'Approve leaves',
		"to": '/leave/approve-leaves',
		"parentId": 7,
		"permission_code": "approve_leave",
		"checkEdit": true
	},
	{
		"id": 13,
		"icon": 'calendar-alt',
		"label": 'Applied leaves',
		"to": '/leave/applied-leaves',
		"parentId": 7,
		"displayToAll": true
	},
	{
		"id": 19,
        "icon": 'money',
        "label": 'Salary',
		"to": '/salary',
		"displayToAll": true
    },
	{
		"id":8,
		"label":"Create Salary Slip",
		"to": '/salary/create-salary-slip',
		"permission_code": "salary",
		"displayToAll": false,
		"parentId":19,
		"checkCreate": true
	},
	{
		"id":9,
		"label":"View Salary Slip",
		"to": '/salary/view-salary-slip',
		"permission_code": "salary",
		"displayToAll": true,
		"parentId":19
	},
	{
		"id":10,
		"label":"Edit Salary",
		"to": '/salary/edit-salary-slip',
		"permission_code": "salary",
		"displayToAll": false,
		"checkEdit": true,
		"parentId":19
	},
	{
		"id":17,
		"label":"Generate Salary",
		"to": '/salary/generate-salary-slip',
		"permission_code": "salary",
		"displayToAll": false,
		"checkEdit": true,
		"parentId":19
	},
	{
		"id": 14,
		"icon": "calendar-check-o",
		"label": "Attendance",
		"to": "/attandance",
		"permission_code": "attendance"
	},
	{
		"id": 15,
		"icon": "calendar",
		"label": "My Attendance",
		"to": "/myAttendance",
		"displayToAll": true
	},
	{
		"id": 16,
		"icon": "users",
		"label": "All faculties",
		"to": "/allFaculties",
		"permission_code": "allFaculties"
	}
];

export const studentMetisMenu = [
	{
		"id": 1,
		"icon": "dashboard",
		"label": "Dashboard",
		"to": "/",
		"displayToAll": true
	},
	{
		"id": 2,
		"icon": "file-text-o",
		"label": "Registration form",
		"to": "/studentRegistration",
		"permission_code": "studentRegistration"
	},
	{
		"id": 3,
		"icon": "tasks",
		"label": "Download documents",
		"to": "/downloadDocuments",
	},
	{
		"id": 4,
		"icon": "money",
		"label": "Pay entrance fees",
		"to": "/collegeFees",
	},
	{
		"id": 5,
		"icon": "bullhorn",
		"label": "Exam status/fee payment",
		"to": "/feeCalculation",
	}
];
